<template>
  <div>
    <div class="worker" @click="dialogTableVisible = true">
      <div v-if="choseStaffId == ''">
        <img src="@public/img/worker.png" alt />
        选择员工
      </div>
      <div v-else>员工：{{ showStaff }}</div>
    </div>
    <div class="headline">选择油卡</div>
    <template v-for="(item, index) in OilCardArr">
      <div
        class="oil-item"
        :class="nowIdx == index ? 'oil-item_active' : ''"
        :key="index"
        @click="selectOil(item, index)"
      >
        <span>{{ item.type_name }}</span>
        <span>{{ item.balance }}</span>
      </div>
    </template>
    <!-- 員工选择弹窗 -->
    <el-dialog title="选择员工" :visible.sync="dialogTableVisible">
      <div class="poPup">
        <div
          v-for="item in staffData"
          :key="item.id"
          :class="choseStaffId == item.id ? 'chose' : ''"
          @click="clickButton(item.id)"
        >
          {{ item.name }}（{{ item.id }}）
        </div>
      </div>
    </el-dialog>
  </div>
</template>
<script>
import { equipmentList, getOilCardsDetail } from "@/api/vip";
import { employeeList } from "@/api/employee";
import { getOilCards } from "@/api/ic";
import { mapGetters } from "vuex";
import { Avatar, Switch } from "element-ui";
export default {
  computed: {
    ...mapGetters(["token", "app_id"])
  },
  data() {
    return {
      dialogTableVisible: false,
      activeName: "选择油品",
      moneyTabs: ["选择油品"],
      tableList: [],
      staffData: [],
      OilCardArr: [], // 油卡列表
      choseStaff: "",
      nowIdx: 0,
      choseStaffId: "", //选择员工的id，
      showStaff: ""
    };
  },
  watch: {
    OilCardArr: {
      handler(val) {
        this.$parent.recount(val[this.nowIdx]);
      },
      deep: true
    }
  },
  async mounted() {
    this.getYuanGong();
  },
  methods: {
    setCard(val) {
      this.OilCardArr = val;
    },
    // 员工选择弹窗
    clickButton(id) {
      this.choseStaffId = id;
      this.showStaff = this.staffTitleTransiform(id);
      localStorage.setItem("choseStaffId", id);
      this.dialogTableVisible = false;
    },
    staffTitleTransiform(id) {
      let title = "";
      this.staffData.forEach(item => {
        if (item.id == Number(id)) {
          title = item.name + "(" + item.id + ")";
        }
      });
      return title;
    },
    selectOil(item, idx) {
      this.nowIdx = idx;
      this.$parent.recount(item);
    },
    getYuanGong() {
      employeeList({ token: this.token, app_id: this.app_id }).then(res => {
        if (res.code == 200) {
          this.staffData = res.data;
          if (localStorage.getItem("choseStaffId")) {
            this.choseStaffId = localStorage.getItem("choseStaffId");
            this.showStaff = this.staffTitleTransiform(this.choseStaffId);
          }
        }
      });
    }
  }
};
</script>
<style lang="scss" scoped>
.headline {
  height: 50px;
  line-height: 50px;
  padding-left: 14px;
}
.worker {
  height: 50px;
  background: #409eff;
  border-radius: 10px;
  padding-left: 14px;
  display: flex;
  color: #fff;
  align-items: center;
  font-size: 20px;
  cursor: pointer;
  img {
    height: 30px;
    margin-right: 10px;
  }
}
// 员工选择弹窗
.poPup {
  width: 100%;
  display: flex;
  flex-wrap: wrap;
  justify-content: space-around;
  div {
    width: 180px;
    height: 60px;
    border-radius: 5px;
    border: 1px solid #ccc;
    text-align: center;
    line-height: 60px;
    margin-bottom: 20px;
    cursor: pointer;
  }
  .chose {
    background: #8cc5ff;
    color: #fff;
  }
}
.el-card {
  font-size: 16px;
  color: #ffffff;
  background: #f56c6c !important;
  .card-body {
    display: flex;
    align-items: center;
    cursor: pointer;
    justify-content: space-between;
    .order-item-info {
      display: flex;
      font-size: 14px;
      color: #f2f2f2;
      flex-direction: column;
      justify-content: space-between;
    }
  }
}
.oil-item {
  height: 50px;
  line-height: 50px;
  background: #f2f2f2;
  color: #22242f;
  cursor: pointer;
  font-size: 16px;
  align-items: center;
  padding-left: 10px;
  border-radius: 10px;
  margin-bottom: 15px;
  span:nth-child(1) {
    font-size: 20px;
  }
  span:nth-child(2) {
    margin-left: 10px;
  }
  span:nth-child(2) {
    margin-left: 10px;
  }
}
.oil-item_active {
  background: #409eff;
  color: #f2f2f2;
}
</style>
